var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert alert-danger",domProps:{"innerHTML":_vm._s(_vm.contents)}})
}
var staticRenderFns = []

export { render, staticRenderFns }